export default __webpack_public_path__ + "static/media/revenge-porn-landing.2efee3f5.png";